import {IMessageCode, isMessageCode, LogLevel, MessageCode} from "@mindpath/shared";
import {captureException, captureMessage} from "@sentry/angular";
import {MapError} from "./error-mapper";

export function isErrorCaptured(msg: unknown): boolean {
  if (!isMessageCode(msg)) {
    return false;
  }
  return !!msg.meta?.["captured"];
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export function CaptureError(msg: unknown, opt?: { noLog?: boolean, details?: string, stackFrom?: Function }): IMessageCode {

  let error: IMessageCode|undefined;
  try {


    const captureFrom = opt?.stackFrom ?? CaptureError;

    error = MapError(msg, {noLog: true, stackFrom: captureFrom});

    let meta = (error as unknown as { meta?: Record<string, unknown>; }).meta;
    if (!meta) {
      meta = {};
      (error as unknown as { meta: Record<string, unknown>; }).meta = meta;
    }
    if (isErrorCaptured(error)) {
      return error;
    }

    meta["captured"] = true;
    if (error.level >= LogLevel.Error) {
      if (!opt?.noLog) {
        console.error(error, opt?.details);
      }
      captureException(error, {
        level: error.level === LogLevel.Error ? 'error' : 'fatal',
        tags: {
          code: error.code,
        }
      });
    } else if (error.level === LogLevel.Warn) {
      if (!opt?.noLog) {
        console.warn(error, opt?.details);
      }
      captureMessage(error.devDescription ?? error.code ?? error.message, {
        level: 'warning',
        tags: {
          code: error.code,
        }
      });
    }
    return error;
  } catch (e) {
    if (!error) {
      error = MessageCode.Unknown_Browser_Exception;
    }

    let exception = e;
    if (!(e instanceof Error)) {
      exception = new Error(`Error capturing error: \`${JSON.stringify(e)}\``);
    }
    console.error('Error capturing error', e);
    try {
      captureException(exception, {
        level: 'error',
        tags: {
          code: error.code,
        }
      });
    } catch (e) {
      console.error('Error capturing error when catching capture error', e);
    }
    return error;
  }

}
